import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core'
import { MediaModule, OutletModule, PageComponentModule } from '@spartacus/storefront'
import { SafePipe } from '../../pipes/safe.pipe'
import { SharedModule } from '../shared/shared.module'
import { CustomProductDetailsTabComponent } from './custom-product-details-tab/custom-product-details-tab.component'
import { CustomTabParagraphContainerComponent } from './custom-tab-paragraph-container/custom-tab-paragraph-container.component'
import { EnvironmentalInfoTabComponent } from './environmental-info-tab/environmental-info-tab.component'
import { ProductDeliveryTabComponent } from './product-delivery-tab/product-delivery-tab.component'
import { ProductSpecsTabComponent } from './product-specs-tab/product-specs-tab.component'

@NgModule({
  declarations: [
    CustomTabParagraphContainerComponent,
    ProductSpecsTabComponent,
    EnvironmentalInfoTabComponent,
    CustomProductDetailsTabComponent,
    ProductDeliveryTabComponent,
    SafePipe
  ],
  imports: [CommonModule, I18nModule, SharedModule, OutletModule, PageComponentModule, MediaModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        CMSTabParagraphContainer: {
          component: CustomTabParagraphContainerComponent
        },
        EnvironmentalInfoTabComponent: {
          component: EnvironmentalInfoTabComponent
        },
        ProductDetailsTabComponent: {
          component: CustomProductDetailsTabComponent
        },
        ProductDeliveryTabComponent: {
          component: ProductDeliveryTabComponent
        },
        ProductSpecsTabComponent: {
          component: ProductSpecsTabComponent
        },
        ProductDocumentsTabComponent: {
          component: CustomTabParagraphContainerComponent
        }
      }
    })
  ],
  exports: [
    CustomTabParagraphContainerComponent,
    EnvironmentalInfoTabComponent,
    CustomProductDetailsTabComponent,
    ProductDeliveryTabComponent,
    ProductSpecsTabComponent
  ]
})
export class CustomProductTabModule {}
